import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchDashboardDataRequest } from '@/api/dashboard';
import {
  tryFetchDashboardData,
  fetchDashboardData,
  setDashboardData,
} from '../actions';
import { dashboardData as selectDashboardData } from '../selectors';

const tryFetchDashboardDataEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchDashboardData.match),
    withLatestFrom(state$),
    map(([, state]) => {
      const dashboardData = selectDashboardData(state);

      if (!dashboardData) {
        return fetchDashboardData();
      }

      return {
        type: 'DASHBOARD_DATA_ALREADY_FETCHED',
      };
    }),
  );

const fetchDashboardDataEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDashboardData.match),
    request(fetchDashboardDataRequest, fetchDashboardData),
  );

const fetchDashboardDataSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDashboardData.succeeded.match),
    map(({ payload: { data } }) => setDashboardData(data)),
  );

export default combineEpics(
  tryFetchDashboardDataEpic,
  fetchDashboardDataEpic,
  fetchDashboardDataSucceededEpic,
);
